import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeModule } from './screens/home/home.module';
import { MenuModule } from './screens/menu/menu.module';
import { IntercertorSpinner } from './services/http-interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    //FilterProjectPipe
  ],
  imports: [
    BrowserModule,
    HomeModule,
    AppRoutingModule,
    MenuModule,
    HttpClientModule,
    NoopAnimationsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: IntercertorSpinner, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
